
  document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('globalQuoteModal');
    const closeBtn = document.getElementById('closeGlobalModal');
    const fileInp = document.getElementById('modal-file-upload');
    const fileNameDisplay = document.getElementById('modal-file-name');

    // 1. 全局监听点击事件：只要点击了 ID 为 openQuoteModal 的元素（无论它在哪里）
    document.addEventListener('click', function(e) {
      // 检查点击的是否是打开按钮（或者是按钮内的文字）
      const trigger = e.target.closest('#openQuoteModal');
      if (trigger) {
        e.preventDefault();
        modal.classList.add('is-active');
        document.body.style.overflow = 'hidden'; // 锁定背景滚动
      }
    });

    // 2. 关闭逻辑
    const closeModal = () => {
      modal.classList.remove('is-active');
      document.body.style.overflow = ''; // 恢复滚动
    };

    closeBtn?.addEventListener('click', closeModal);

    // 点击遮罩层空白处关闭
    modal?.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

    // 3. 文件名显示逻辑
    fileInp?.addEventListener('change', function() {
      fileNameDisplay.textContent = this.files[0] ? this.files[0].name : "No file selected";
    });
  });


  